"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const day_off_1 = require("./day-off");
const silo_hopper_1 = require("./silo-hopper");
const rfid_log_1 = require("./rfid-log");
const stockpile_1 = require("./stockpile");
const planning_1 = require("./planning");
const adjustmentReducer = (0, redux_1.combineReducers)({
    silo: silo_hopper_1.adjustmentSiloReducer,
    rfid: rfid_log_1.adjustmentRfidLogReducer,
    hauling: planning_1.planningHaulingReducer,
    dayoff: day_off_1.adjustmenttDayOffReducer,
    planning: planning_1.adjustmentPlanningReducer,
    production: planning_1.planningProductionReducer,
    stockpile: stockpile_1.adjustmentStockpileReducer,
    transhipment: planning_1.planningTranshipmentReducer,
});
exports.default = adjustmentReducer;
